import React, { useEffect, useState, useRef } from 'react';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-30px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(16px)',
    transition: `opacity 0.5s ease ${delay}s, transform 0.5s ease ${delay}s`,
    willChange: isVisible ? 'auto' : 'opacity, transform'
  }} data-id="element-291">
      {children}
    </div>;
}
export function Section({
  children,
  className = '',
  variant = 'dark',
  id
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'dark' | 'light' | 'blue' | 'black';
  id?: string;
}) {
  const bgColors = {
    dark: 'bg-white',
    light: 'bg-gray-50',
    blue: 'bg-teal-50',
    black: 'bg-white'
  };
  return <section id={id} className={`py-14 md:py-[100px] px-5 md:px-4 ${bgColors[variant]} ${className}`} data-id="element-292">
      <div className="max-w-[680px] mx-auto w-full" data-id="element-293">{children}</div>
    </section>;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick,
  href
}: {
  children: React.ReactNode;
  variant?: 'primary' | 'gold' | 'outline';
  className?: string;
  onClick?: () => void;
  href?: string;
}) {
  const baseStyles = 'block w-full text-center font-bold rounded-xl min-h-[52px] py-4 px-6 transition-all duration-300 shadow-lg flex flex-col items-center justify-center gap-1 md:hover:-translate-y-1 active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-green hover:bg-brand-greenHover text-white shadow-brand-green/20 animate-pulse-slow',
    gold: 'bg-gradient-to-r from-brand-gold to-yellow-300 hover:from-yellow-400 hover:to-yellow-200 text-black shadow-brand-gold/20',
    outline: 'bg-transparent border-2 border-brand-green text-brand-green hover:bg-brand-green/10'
  };
  const Element = href ? 'a' : 'button';
  return <Element href={href} onClick={onClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-294">
      {children}
    </Element>;
}